<template>
  <div class="page" :style="`width:${dispW}px; height:${dispH}px;color:white;`">
    <el-container style="line-height: 0px; height: 100%">
      <el-container>
        <el-main :height="`${dispH}px`" style="padding-left: 0px">
          <el-row>
            <el-col :span="12">
              <MapForm
                :isSelectVisibleBoolen="false"
                parentForm="fourmaps"
                :indexInForm="0"
                :dispW="dispW / 2"
                :dispH="dispH / 2 - 30"
                :colorBarWidth="90"
                :colorBarHeight="dispH / 2 - 29"
                :mapValues="mapValues"
              ></MapForm>
            </el-col>
            <el-col :span="12">
              <MapForm
                :isSelectVisibleBoolen="false"
                parentForm="fourmaps"
                :indexInForm="1"
                :dispW="dispW / 2"
                :dispH="dispH / 2 - 30"
                :colorBarWidth="90"
                :colorBarHeight="dispH / 2 - 29"
                :mapValues="mapValues"
              ></MapForm>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <MapForm
                :isSelectVisibleBoolen="false"
                :indexInForm="2"
                parentForm="fourmaps"
                :dispW="dispW / 2"
                :dispH="dispH / 2 - 30"
                :colorBarWidth="90"
                :colorBarHeight="dispH / 2 - 29"
                :mapValues="mapValues"
              ></MapForm>
            </el-col>
            <el-col :span="12">
              <MapForm
                :isSelectVisibleBoolen="false"
                parentForm="fourmaps"
                :indexInForm="3"
                :dispW="dispW / 2"
                :dispH="dispH / 2 - 30"
                :colorBarWidth="90"
                :colorBarHeight="dispH / 2 - 29"
                :mapValues="mapValues"
              ></MapForm>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import MapForm from "./MapForm.vue";
export default {
  name: "FourMaps",
  data() {
    return {};
  },
  created() {},
  mounted: function () {
    this.$emit("hide-waiting");
  },
  props: {
    dispW: {
      type: Number,
      default: window.screen.width - 30 - 500
    },
    dispH: {
      type: Number,
      default: window.screen.height - 80 - 30
    },
    mapValues: {
      type: Object,
      defaultL: () => {
        return {};
      }
    },
    value: Boolean
  },
  components: {
    MapForm
  },

  watch: {},
  computed: {},
  methods: {}
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/topography/components/FourMaps.vue